import { LocalePrefix, Pathnames } from 'next-intl/routing'

export const defaultLocale = 'en' as const
export const locales = ['en', 'ar'] as const

export const pathnames: Pathnames<typeof locales> = {
  '/': '/',
  '/pathnames': {
    ar: '/pathnames',
    en: '/pathnames'
  }
}

export const localePrefix: LocalePrefix<typeof locales> = 'always'

export type AppPathnames = keyof typeof pathnames
